import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "fixed-top"
};
const _hoisted_2 = {
  class: "filter"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "sort__down"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "sort__down"
}, null, -1);
const _hoisted_5 = {
  style: {
    "margin-top": "10px",
    "padding-top": "100px"
  }
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 0,
  class: "sellout"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "part3_list_li_addr"
};
const _hoisted_10 = {
  class: "part3_list_li_title"
};
const _hoisted_11 = {
  style: {
    "margin": "5px",
    "color": "#cccccc",
    "height": "25px",
    "line-height": "25px"
  }
};
const _hoisted_12 = {
  class: "part3_list_li_kf",
  style: {
    "float": "left"
  }
};
const _hoisted_13 = {
  style: {
    "float": "right",
    "margin-right": "5px"
  }
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  key: 0,
  class: "part3_tj",
  style: {
    "padding-top": "110px"
  }
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  key: 1,
  class: "part3_tj",
  style: {
    "padding-top": "110px"
  }
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  class: "screen-btns"
};
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "bottomH120"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_search = _resolveComponent("van-search");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_search, {
    shape: "round",
    modelValue: $setup.condition,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.condition = $event),
    onSearch: $options.onSearch,
    placeholder: "試試搜索320D"
  }, null, 8, ["modelValue", "onSearch"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = $event => $setup.toggleScreen('mac')),
    class: _normalizeClass(["filter-nav", $setup.curType == 'mac' ? 'filter-nav--active' : ''])
  }, [_createTextVNode("設備類型"), _hoisted_3], 2), _createElementVNode("div", {
    onClick: _cache[2] || (_cache[2] = $event => $setup.toggleScreen('tag')),
    class: _normalizeClass(["filter-nav", $setup.curType == 'tag' ? 'filter-nav--active' : ''])
  }, [_createTextVNode("設備標籤"), _hoisted_4], 2), _createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = (...args) => $options.orderBy && $options.orderBy(...args)),
    class: "filter-nav"
  }, [_createElementVNode("div", {
    class: _normalizeClass($setup.currentType == 'PushTime' ? 'filter-nav--active' : '')
  }, "上架時間", 2), _createElementVNode("div", null, [_createElementVNode("div", {
    class: _normalizeClass(["sort__up", $setup.currentType == 'PushTime' && $setup.sortType == 'desc' ? 'sort__up--active' : ''])
  }, null, 2), _createElementVNode("div", {
    class: _normalizeClass(["sort__down", $setup.currentType == 'PushTime' && $setup.sortType == 'asc' ? 'sort__down--active' : ''])
  }, null, 2)])])])]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.MyDeviceListForShow, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "part3_list_li",
      onClick: $event => $options.goShowdetail(item),
      key: index
    }, [item.C_Tag != null && item.C_Tag != '' ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.C_Tag), 1)) : _createCommentVNode("", true), _createElementVNode("img", {
      src: item.C_Img,
      style: {
        "width": "100%",
        "height": "140px",
        "border-radius": "3px"
      }
    }, null, 8, _hoisted_8), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_9, _toDisplayString(item.C_Province) + "-" + _toDisplayString(item.C_City), 1)]), _createElementVNode("div", _hoisted_10, _toDisplayString(item.C_ActivityTitle), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, [_createTextVNode(" 查看 "), _createVNode(_component_van_icon, {
      name: "arrow"
    })]), _createElementVNode("span", _hoisted_13, [_createVNode(_component_van_icon, {
      name: "eye-o",
      size: "15px",
      style: {
        "margin": "0 2px"
      }
    }), _createTextVNode(" " + _toDisplayString(item.I_ViewNum), 1)])])], 8, _hoisted_6);
  }), 128)), $data.MyDeviceListForShow.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_van_empty, {
    description: "暫無數據"
  })])) : _createCommentVNode("", true)]), _createVNode(_component_van_popup, {
    closeable: "",
    style: {
      width: '100%'
    },
    customClass: "screen border-top",
    position: "top",
    show: $setup.showScreen,
    "onUpdate:show": _cache[6] || (_cache[6] = $event => $setup.showScreen = $event)
  }, {
    default: _withCtx(() => [$setup.curType == "mac" ? (_openBlock(), _createElementBlock("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.macTypelist, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "checkboxs",
        key: index,
        onClick: $event => $options.TagcheckChange_mac(item.Value)
      }, [_createElementVNode("span", {
        class: _normalizeClass(["checkboxsspan", {
          is_checked: $data.checkMacTypes.includes(item.Value)
        }])
      }, _toDisplayString(item.Value), 3)], 8, _hoisted_16);
    }), 128))])) : _createCommentVNode("", true), $setup.curType == "tag" ? (_openBlock(), _createElementBlock("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tagList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "checkboxs",
        key: index,
        onClick: $event => $options.TagcheckChange_tag(item.Value)
      }, [_createElementVNode("span", {
        class: _normalizeClass(["checkboxsspan", {
          is_checked: $data.checkTags.includes(item.Value)
        }])
      }, _toDisplayString(item.Value), 3)], 8, _hoisted_18);
    }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [_createElementVNode("button", {
      onClick: _cache[4] || (_cache[4] = (...args) => $options.reset && $options.reset(...args)),
      class: "btn bg-yellowLight"
    }, "重置"), _createElementVNode("button", {
      onClick: _cache[5] || (_cache[5] = (...args) => $options.selectClick && $options.selectClick(...args)),
      class: "btn bg-common"
    }, "確定")])]),
    _: 1
  }, 8, ["show"]), _hoisted_20], 64);
}